// @flow
import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";

import { buildFacebaseItemJson } from "../../components/companies/CompileCompanytoJson";
import FacebaseItemRedux from "../../containers/facebases/FacebaseItemRedux";

type FacebaseListPropsType = {
  facebases: Array<*>,
  isAdmin?: boolean,
  company: { [key: string]: * }
};

class FacebaseList extends Component<FacebaseListPropsType, *> {
  constructor(props: FacebaseListPropsType) {
    super(props);
  }

  render(): * {
    const facebases = this.props.facebases;
    const list =
      facebases &&
      facebases.map((facebase: *, i: number): * => {
        let facebaseForm = buildFacebaseItemJson(facebase);

        return (
          <FacebaseItemRedux
            key={"facebase" + i}
            facebase={facebaseForm}
            company={this.props.company}
            isAdmin={this.props.isAdmin}
          />
        );
      });
    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <List component="nav">
              <Divider light />
              {list}
            </List>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default FacebaseList;
